import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  hasMore: true,
  records: []
};

export default function couponProdList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取优惠券适用商品列表(分页)
    case ACTION_TYPES.GET_COUPON_PROD_PAGING_LIST:
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    default:
      result = state;
  }
  return result;
}
